<!--公告及新闻稿-->
<template>
  <!--内容-->
  <div class="content_width_box">
        <div class="content_title">
          <div class="title_left_h2">企业管治文件</div>
        </div>
        <FileTitleListView :messageList="businessFileList.list" :perPage="businessFileList.perPage" detailRouter="invstorDetail"></FileTitleListView>
      </div>
</template>
<script>
import FileTitleListView from '../../titleNews/FileTitleListView'
import UtilEvent from '../../utils/UtilEvent.js'
  export default {
    name: 'investorBusinessFile',
    components:{UtilEvent,FileTitleListView},
    props: ['businessFileList'],
    created(){
        
    },
    data () {
      return {
        
      }
    },
    computed:{
      
    },
    methods:{
      
      
    },
    watch:{
      
    },
    mounted(){
      
    },
   
  }
  </script>

